import AccountBlockModal, { ACCOUNT_BLOCK_MODAL } from './modal';

export { ACCOUNT_BLOCK_MODAL };

export default AccountBlockModal;
